import {
    setAppSideBarItem,
    setArchiveItem,
    setArchiveTableLoading,
    setSideBarLoading,
} from "store/actions/archiveAction";
import axios from "../axios/axios";
import { errorDispatcher, getOptionsQuery, openArchiveUrl } from "helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { appSetLoading } from "store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { DateToString } from "../components/Reports/DateFilter";
import fileDownload from "js-file-download";
import { store } from "store/store";

const { REACT_APP_BASE_URL_LOCAL, REACT_APP_BASE_URL } = process.env;

export const apiGetArchiveSideBar = (token) => (dispatch) => {
    axios
        .get("/documents/types", {
            // headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            dispatch(setAppSideBarItem(response?.data?.types ?? []));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch, false);
        })
        .finally(() => {
            dispatch(setSideBarLoading());
        });
};

export const apiGetArchiveList =
    ({ pagination, token, key, sort, search }) =>
        (dispatch, getState) => {
            let options = getOptionsQuery(pagination, search, sort);

            dispatch(appSetLoading());
            axios
                .get(`/documents`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: options,
                })
                .then((response) => {
                    dispatch(setTableData(response.data?.docs, response.data.paginate));
                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        };
export const apiGetActiveArchiveList =
    ({ pagination, token, type }) =>
        (dispatch) => {
            dispatch(appSetLoading());
            let options = getOptionsQuery(pagination);
            axios
                .get(`/documents`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: {
                        ...options,
                        type: type,
                    },
                })
                .then((response) => {
                    dispatch(setTableData(response.data?.docs, response.data.paginate));

                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        };

export const apiDeleteArchiveItem = (selectedIds, token, tab, callback, items) => (dispatch, getState) => {
    dispatch(appSetLoading());
    for (const item of items) {
        axios
            .delete(`${item?.url}?token=${item.token}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
                dispatch(apiSetAlert(response.data.message, "success"));
                if (callback) callback();
            })
            .catch((error) => {
                errorDispatcher(error, dispatch);
            });

    }
};
export const apiModalDeleteArchiveItem = ({ token, item, callback }) => (dispatch, getState) => {
    const res = axios
        .delete(`${item?.url}?token=${item.token}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            callback();
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
            callback(error)
        });
    return res;
};

export const apiGetArchiveItem = ({ token, type, typeId }) => {
    const { dispatch } = store
    const res = axios
        .get(`/documents`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                type,
                typeId,
            },
        })
        .then((response) => {

            return response;
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);

        });
    return res;
};

export function openArchiveItem(dispatch, item) {
    // openArchiveUrl(item)
    const { getState } = store
    const token = getState().businessReducer.business?.token;
    const url = item.url + `?token=${item.token}`;
    dispatch(appSetLoading());
    axios
        .get(url, {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
        })
        .then((response) => {
            dispatch(appSetLoading(false));
            const now = DateToString(Date.now()).replace("/", "_")
            const fileName = item.fileName;
            fileDownload(response.data, `${fileName}`);
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
}
